<template>
  <div class="loginPop">
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <div class="loginPopContent">
        <div class="contents">
          <form @submit.prevent="onSubmit">
            <div class="content_box">
              <div class="title_user">{{ $t("User.Login.Login") }}</div>

              <div
                class="inputbox"
                :class="[language == 'en' ? 'en_indent' : 'zh_indent']"
              >
                <div class="form_name">
                  <div>{{ $t("User.Login.UserName") }} :</div>
                </div>

                <div class="form_input">
                  <ValidationProvider
                    :name="$t('fields.userName')"
                    rules="userName|required"
                    v-slot="v"
                    vid="userName"
                  >
                    <input
                      v-model="userName"
                      type="text"
                      :placeholder="$t('User.Login.TipUserName')"
                    />
                    <span class="tip_validate">{{ v.errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div
                class="inputbox"
                :class="[language == 'en' ? 'en_indent' : 'zh_indent']"
              >
                <div class="form_name">
                  <div>{{ $t("User.Login.Password") }} :</div>
                </div>

                <div class="form_input">
                  <ValidationProvider
                    :name="$t('fields.password')"
                    rules="required|min"
                    v-slot="v"
                  >
                    <input
                      v-model="password"
                      type="password"
                      :placeholder="$t('User.Login.TipPassword')"
                    />
                    <span class="tip_validate">{{ v.errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <!-- <div class="loginBtn" @click="ToUserLogin()">
             
              </div>-->
              <!--     :class="[invalid ? 'abledClass' : 'disabledClass']" -->
              <div
                class="loginBtn"
                @click="ToUserLoginFun(handleSubmit)"
                type="submit"
              >
                {{ $t("User.Login.Login") }}
              </div>
              <div class="third" @click="emitThirdUserLogin()">
                <img
                  height="22px"
                  style="margin-top: 20px"
                  src="@/assets/image/User/third.png"
                  alt=""
                />
              </div>
              <div class="register">
                <div @click="register()">{{ $t("User.Login.Register") }}</div>
                |
                <div @click="forget()">{{ $t("User.Login.Forget") }}</div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapMixin } from "@/util/mixin";
// import { userLogin, checkJwt } from "@/axios/user";
import { userLogin, checkJwt } from "@/axios/api";
import bus from "@/bus";
export default {
  mixins: [mapMixin],
  data() {
    return {
      userName: "",
      password: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    emitThirdUserLogin() {
      bus.$emit("ThirdUserLogin");
    },
    onSubmit() {},
    forget() {
      this.$router.push("/forget");
    },
    register() {
      this.$router.push("/register");
    },
    ToUserLoginFun() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        } else {
          this.ToUserLogin();
        }
      });
    },
    async ToUserLogin() {
      var param = {
        loginName: this.userName,
        password: this.password,
      };
      var res = await userLogin(param);
      if (res.status == 200) {
        if (res.data.code == 200) {
          var token = res.data.data.token;
          var LoginName = res.data.data.user.loginName;
          window.localStorage.setItem("token", token);
          window.localStorage.setItem("userId", res.data.data.user.id);
          window.localStorage.setItem("loginName", LoginName);
          this.setLoginName(LoginName);
          this.$message({
            duration: 1000,
            type: "success",
            message: this.$t("Verification.LoginOk"),
            center: true,
          });
          console.log(this.$route.query);
          console.log(JSON.stringify(this.$route.query) == "{}");
          // if (this.$route.query.redirect) {
          //   this.$router.push(`${this.$route.query.redirect }`);
          // } else {
          //   this.$router.push("/");
          // }
          if (JSON.stringify(this.$route.query) == "{}") {
            this.$router.push("/");
          } else {
            if (this.$route.query.redirect) {
              this.$router.push(`${this.$route.query.redirect}`);
            } else {
              this.$router.push("/");
            }
          }
        } else {
          this.$refs.form.setErrors({
            userName: this.$t("Verification.LoginErr"),
          });
        }
      } else {
        this.$refs.form.setErrors({
          userName: this.$t("Verification.LoginErr"),
        });
      }
    },
    closeLoginPop() {
      bus.$emit("closeLoginPopshow");
    },
  },
  watch: {
    language() {
      this.$router.go(0);
    },
  },
};
</script>

<style lang="scss" scoped>
.tip_validate {
  text-align: left;
  display: inline-block;
  float: left;
}
.third {
  cursor: pointer;
}
.loginPop {
  width: 100%;
  margin-top: 40px;
  padding: 10px 0;
  background: #fff;
  .loginPopContent {
    padding-top: 20px;
    width: 100%;
    // background: url("../../assets/img/login_bg2.png");
    background-size: 100% 100%;
    margin: auto;
    .header {
      display: flex;
      height: 46px;
      justify-content: flex-end;
      align-items: center;
      color: #fff;
      .title {
        font-size: 18px;
      }
      .close {
        cursor: pointer;
        i {
          font-size: 22px;
        }
      }
    }
    .contents {
      margin-bottom: 20px;
      .content_box {
        opacity: 0.7;
        padding: 20px 30px;
        .title_user {
          text-align: center;
          color: #000;
          font-size: 22px;
          margin-bottom: 20px;
          font-weight: 600;
        }
      }

      .inputbox {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        border: 1px solid #666;
        border-radius: 4px;
        padding: 0px 10px;
        height: 48px;
        line-height: 48px;
        margin-bottom: 42px;
        .form_name {
          min-width: 90px;
          text-align: left;
          color: #666;
          font-size: 16px;
        }
        .form_input {
          // position: relative;
          flex: 1;
          input {
            background: transparent;
            border: none;
            width: 100%;
            outline: none;
            color: #000;
            font-size: 16px;
          }
          .tip_validate {
            position: absolute;
            top: 50px;
            line-height: 16px;
            left: 10px;
            font-size: 14px;
            color: #ac233f;
          }
        }
      }

      .register {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        div {
          margin: 20px 20px;
          cursor: pointer;
          color: #999;
          &:hover {
            color: #0057aa;
          }
        }
      }
      .loginBtn {
        // box-shadow: 0px 2px 4px #020920;
        margin-top: 20px;
        width: 100%;
        height: 48px;
        line-height: 48px;
        border-radius: 4px;
        text-align: center;
        color: #fff;
        font-size: 16px;
        cursor: pointer;
        background: linear-gradient(
          to right,
          rgba(0, 167, 220, 1),
          rgba(0, 87, 170, 1)
        );
        transition: 0.2s;
      }
      .disabledClass {
        transition: 0.2s;
        background: linear-gradient(
          to right,
          rgba(0, 167, 220, 1),
          rgba(0, 87, 170, 1)
        ); /* 标准的语法 */
      }
      .abledClass {
        transition: 0.2s;
        background: #ccc !important;
        cursor: not-allowed;
      }
      .loginBtn:hover {
        transition: 0.2s;
        background: linear-gradient(
          to right,
          rgba(0, 135, 255, 0.6),
          rgba(0, 87, 170, 0.6)
        ); /* 标准的语法 */
      }
    }
  }
}
input::placeholder {
  font-size: 14px;
}
.login_box {
  margin-top: 30px;
  text-align: center;
  .home_logo_img4 {
    width: 70px;
    height: 70px;
    margin-right: 20px;
  }
  .home_logo_img1 {
    width: 126px;
    height: 70px;
    margin-right: 20px;
  }
}
</style>